module.exports = __webpack_public_path__ + "media/src/assets/noitemsuser-4193b30c0265537e329c4127e8766934.png";